import { WifiOff } from "lucide-react";
import { usePWA } from "@/hooks/usePWA";

const OfflineIndicator = () => {
  const { isOnline } = usePWA();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-destructive text-destructive-foreground py-2 px-4 flex items-center justify-center gap-2 text-sm font-medium">
      <WifiOff className="h-4 w-4" />
      <span>Sin conexión - Mostrando contenido guardado</span>
    </div>
  );
};

export default OfflineIndicator;
